import angular from 'angular';
import uiRouter from 'angular-ui-router';
import einzelticketcodeComponent from './einzelticketcode.component';

let einzelticketcodeModule = angular.module('einzelticketcode', [
  uiRouter
])

.component('einzelticketcode', einzelticketcodeComponent)

.name;

export default einzelticketcodeModule;



// WEBPACK FOOTER //
// ./client/app/common/forms/einzelticketcode/einzelticketcode.js